import React from "react";
import cx from "classnames";
import styles from "./Heading.module.scss";

export interface HeadingProps {
  className?: string;
  tag: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  size?: "f1" | "f2" | "f3" | "f4" | "f5" | "f6";
  lineHeight?: "lh-title" | "lh-solid" | "lh-copy";
  flushTop?: boolean;
  flushBottom?: boolean;
  flush?: boolean;
}

const Heading: React.FC<HeadingProps> = ({
  className,
  children,
  tag,
  size,
  lineHeight,
  flush,
  flushTop,
  flushBottom,
}) => {
  return React.createElement(
    tag,
    {
      className: cx(styles.heading, className, size, lineHeight, {
        [styles.flushTop]: flushTop || flush,
        [styles.flushBottom]: flushBottom || flush,
      }),
    },
    children
  );
};

export default Heading;
